// Colors
export const BLACK = '#000';

export const ORANGE = '#ffae33';
export const SOFT_ORANGE = '#ffd786';
export const ORANGE_OPACITY_20 = 'rgba(255, 174, 51, 0.2)';
export const PALE_ORANGE = '#fff0d5';
export const ORANGE_YELLOW = '#ffb000';
export const YELLOWISH_ORANGE = '#ffaf19';
export const SELECTIVE_YELLOW = '#ffb100';
export const MEDIUM_LIGHT_RED_ORANGE = '#ff8d5a';
export const PEACH_SHADOW = '#fff4e3';

export const CYAN_BLUE = '#51d1e2';
export const SOFT_BLUE = '#7276f7';
export const SOFT_BLUE_VIOLET = '#5458e1';
export const SOFT_BLUE_VIOLET_OPACITY_8 = 'rgba(84, 88, 225, 0.08)';
export const ROYAL_BLUE_24 = '#3d0005b9';

export const VERY_LIGHT_GRAY = '#fafafa';
export const WHITEY_GRAY = '#f6f6f6';
export const LIGHT_GRAY = '#e8e8e8';
export const GRAY = '#d3d3d3';

export const WHITE = '#fff';
export const WHITE_32 = '#52e8e8e8';
export const WHITE_TWO = '#fafafa';

export const BLACK_OPACITY = 'rgba(0,0,0,0.12)';
export const LIGHT_BLACK = '#1a1a1a';
export const CAPTION_TEXT = 'rgba(45, 45, 45, 0.6)';
export const BLACK_TEXT_OPACITY = 'rgba(0,0,0,0.6)';
export const NIGHT_RIDER = '#323232';

export const RED = '#ff0000';
export const ERROR_TEXT = '#ff0000';
export const DARKISH_PINK = '#e4525c';

export const GRADIENT_CARD = [SOFT_BLUE, SOFT_BLUE_VIOLET];

export const COLOR_ARRAY_BILL = [ORANGE, SOFT_ORANGE, PALE_ORANGE];

export const MAN_DAYS_COLORS = [
  MEDIUM_LIGHT_RED_ORANGE,
  CYAN_BLUE,
  SOFT_BLUE_VIOLET,
];

export const UNDER_DEVELOPEMENT_COLORS = [GRAY, LIGHT_GRAY, WHITEY_GRAY];

const CARD_SHADOW = {
  GRADIENT: ROYAL_BLUE_24,
  NORMAL: NIGHT_RIDER,
};

// Components & Core-UI
export const POPOVER_COLOR = {
  details: BLACK_TEXT_OPACITY,
  border: GRAY,
  background: VERY_LIGHT_GRAY,
  divider: LIGHT_GRAY,
};

export const TOOLTIP_COLOR = {
  subtitle: BLACK_TEXT_OPACITY,
  background: WHITE,
  divider: LIGHT_GRAY,
  shadow: BLACK,
};

export const CARD = {
  shadow: CARD_SHADOW,
  divider: LIGHT_GRAY,
  background: WHITE,
};

export const PROGRESS_BAR = {
  background: ORANGE_OPACITY_20,
  indicator: ORANGE,
};

export const TEXT = {
  white: WHITE,
  blackOpacity: BLACK_TEXT_OPACITY,
  red: RED,
  black: LIGHT_BLACK,
};

export const PAGE = { default: WHITE_TWO };

export const HEADER = {
  shadow: LIGHT_GRAY,
  borderLogo: LIGHT_GRAY,
};

export const TEXT_INPUT = {
  borderDefault: LIGHT_GRAY,
  borderError: RED,
};

export const BUTTON = {
  default: ORANGE_YELLOW,
  login: YELLOWISH_ORANGE,
};

export const ICONS = {
  default: BLACK,
  selected: SOFT_BLUE_VIOLET,
  unselected: BLACK_TEXT_OPACITY,
};

export const DRAWER = {
  sidebarBackground: WHITE,
  renderBackground: VERY_LIGHT_GRAY,
  renderItem: {
    selected: SOFT_BLUE_VIOLET_OPACITY_8,
  },
};

export const TOAST = {
  background: NIGHT_RIDER,
  actionText: SELECTIVE_YELLOW,
  labelText: WHITE,
};

export const PROJECT_COLLAPSIBLE = {
  chevronUpCircleOutline: SOFT_BLUE_VIOLET,
  showPasswordLabel: SOFT_BLUE_VIOLET,
  deleteProjectText: DARKISH_PINK,
};

export const ACTIVITY_INDICATOR = {
  default: SOFT_BLUE_VIOLET,
};

export const DIVIDER = {
  line: LIGHT_GRAY,
};

export const ANNOUNCEMENT = {
  background: PEACH_SHADOW,
};

export const PROJECT_START_COLOR = SOFT_BLUE_VIOLET;

export const DOWNLOAD_BUTTON = {
  border: SOFT_BLUE_VIOLET,
  text: SOFT_BLUE_VIOLET,
};
